<template>
    <v-dialog v-model="value" persistent :max-width="maxWidth">
        <v-card>
            <v-card-title class="primary modal-title">
                <span>{{ title }}</span>
                <v-spacer/>
                <v-btn icon @click="fecharModal">
                    <v-icon size="20" color="white">close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text style="overflow-x: hidden">
              <div class="box-modal-confirm">
                 <div style="text-align: center">
                     <span class="text-modal-confirm">{{text}}</span><br>
                     <span class="text-modal-confirm">{{secondText}}</span>
                 </div>
              </div>
            </v-card-text>
            <v-layout class="justify-space-between">
                <v-btn class="ml-3 mb-3" @click="cancelarAcao">Não</v-btn>
                <v-btn class="mr-3 mb-3 primary" @click.prevent="confirmarAcao">
                    Sim, continuar
                </v-btn>
            </v-layout>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ModalConfirmarEtapaAnexo',
    props: {
        value: Boolean,
        title: {
            type: String
        },
        text: {
            type: String
        },
        secondText:{
            type: String
        },
        maxWidth: {
            type: String,
            default: '650'
        }
    },
    methods: {
        fecharModal() {
            this.$emit('fecharModalConfirm')
        },
        cancelarAcao() {
            this.$emit('cancelarAcao')
        },
        confirmarAcao() {
            this.$emit('confirmarAcao')
        }
    }
}
</script>

<style lang="stylus" scoped>
    .text-modal-confirm
        color #3A6861
        font-weight 600

    .box-modal-confirm
        display flex
        flex-direction column
        justify-content center
        align-items center
        min-height 100px
</style>